import React from 'react';
import GameHeader from './game-header';
import { global_var } from '../../services/cs-lab-config';

const TypingNinja = () => {

  document.title = "CS Lab | Typing Ninja";

  return (
    <div className="container-fluid p-0">
      <div className="row mt-1">
        <div className="col">
          <GameHeader headerName="Typing Ninja" />
          <iframe
            id="typingNinjaIframe"
            // src={global_var.TYPING_NINJA_ENDPOINT + '?token=' +localStorage.getItem('token')}
            src={global_var.TYPING_NINJA_ENDPOINT + '?token=' + sessionStorage.getItem('token')}
            title="Typing ninja"
            style={{
              width: '100%',
              height: '100vh',
              border: 'none',
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default TypingNinja;
